export function withOverride(originalValue, overrideValue) {
    if (overrideValue === true || overrideValue === false) {
        return overrideValue;
    }
    return !!originalValue;
}
export function optionalDictWithOverride(prop, originalValue, overrideValue) {
    const finalValue = withOverride(originalValue, overrideValue);
    if (finalValue) {
        return { [prop]: true };
    }
    return {};
}
//# sourceMappingURL=universal_bool_helper.js.map